import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarRef as MatSnackBarRef } from '@angular/material/legacy-snack-bar';

@Injectable({
  providedIn: 'root'
})
export class UpdatePWAService {
  constructor(private readonly updates: SwUpdate, private _snackBar: MatSnackBar) {
    this.updates.available.subscribe(event => {
      this.showAppUpdateAlert();
    });


  }
  showAppUpdateAlert() {

    this.doAppUpdate();
  }

  doAppUpdate() {
      this.updates.activateUpdate().then(() => {

        this._snackBar.open('Aplikacija je bila posodobljena', 'Zapri', {
          duration: 3000
        }).afterDismissed()
        .subscribe(() => {
          document.location.reload();
        });
      });
    }


}
